export default {
  ticks: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
};
